module.exports = __webpack_public_path__ + "img/uk-lung-cancer-male.73dfb2ed.png";